<template>
  <div id="map">
    <baidu-map class="map"  @ready="loadedMap" :mapClick="false" :Bounds="{sw:238, ne: 2139}" :center="center" ak="TdjjUm3DDvXztsh31KKjogByHtfBVfAw"  :scroll-wheel-zoom="true" :zoom="zoom" @zoomend="syncCenterAndZoom" :mapStyle="mapStyle" :auto-resize="true" @dragend="dragend">
      <div v-show="fillCitys">
        <bm-boundary v-for="(city, index) in fillCitys" :key="index" :name="city.name" :strokeWeight="1" :fillColor="colorConfig('PM2.5', city.value).color" style="zIndex=998"></bm-boundary>
      </div>
      <bml-heatmap :data="hotData" :max="max" :opacity="100" :radius="10" v-if="hotData" style="zIndex=999" :gradient="g"></bml-heatmap>
      <bm-info-window :show="false"></bm-info-window>
      <div v-if="positions">
        <div v-for="(position, index) in rPoint" :key="index" class="qq" style="position:relative;" >
          <sitIcon :position="position" :zoom="zoom" @tag="showSit?showSitInfo(position.code):''"  v-show="sitIndex!=position.code && type" :type="type" v-if="position[type]!==null"></sitIcon>
          <sitPop :position="position" v-show="sitIndex===position.code" :type="type" @closeP="$emit('showInfo', '')"></sitPop>
        </div>
      </div>
    </baidu-map>
  </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import sitPop from './sitPop'
import sitIcon from './sitIcon'
import colorConfig from '@/common/js/range.js'
import { BmInfoWindow, BmBoundary, BmlHeatmap } from 'vue-baidu-map'
export default {
  name: 'MyMap',
  props: ['positions', 'type', 'showSit', 'fillCitys', 'Pzoom', 'hotData', 'center', 'g', 'mapStyle', 'max'],
  components: {
    BaiduMap,
    BmInfoWindow,
    BmBoundary,
    BmlHeatmap,
    sitPop,
    sitIcon
  },
  data () {
    return {
      zoom: 11,
      sitIndex: null,
      huanIndex: '',
      map: null,
      leftBottom: null,
      rightTop: null,
      rPoint: []
    }
  },
  methods: {
    // 监听4可视区域来插入点位
    lazyPoint () {
      this.rPoint = []
      this.leftBottom = this.map.getBounds().getSouthWest()
      this.rightTop = this.map.getBounds().getNorthEast()
      if(this.positions) {
        this.positions.forEach(p => {
          if ((p.lng >= this.leftBottom.lng && p.lng <= this.rightTop.lng) && (p.lat >= this.leftBottom.lat && p.lat <= this.rightTop.lat)) {
            this.rPoint.push(p)
          }
        })
      }
    },
    // 地图初始化获取地图实力
    loadedMap ({ BMap, map }) {
      this.map = map
      this.lazyPoint()
    },
    // 地图拖拽结束
    dragend () {
      this.lazyPoint()
    },
    // 定义颜色
    colorConfig (type, num) {
      return colorConfig(type, num)
    },
    // 关闭pop
    closePop () {
      this.sitIndex = null
      this.$emit('clearSit')
    },
    // 隐藏
    hideP () {
      this.$emit('hideSit')
    },
    // 显示设备详细+跳转中心+设置zoom
    showSitInfo (code) {
      this.sitIndex = code
      var data
      this.positions.forEach(item => {
        if (item.code === code) {
          data = item
        }
      })
      if(data) {
        this.$emit('setCenter', {
          lng: data.lng,
          lat: data.lat
        })
        this.zoom = 15
        this.$emit('showInfo', data)
      }
    },
    // 双向绑定zoom
    syncCenterAndZoom (e) {
      this.zoom = e.target.getZoom()
    }
  },
  created () {
    this.$bus.$on('showCenter', (code) => {
      this.showSitInfo(code)
    })
    // 如果为热力图缩放等级为4
    if (this.$route.path === '/hotMap') {
      this.zoom = 4
    }
  },
  watch: {
    // 显示点位
    showSit (value) {
      this.$nextTick(() => {
        if (!value) {
          this.huanIndex = this.sitIndex
          this.sitIndex = ''
        } else {
          if (this.huanIndex && !this.sitIndex) {
            this.sitIndex = this.huanIndex
          }
        }
      })
    },
    // 监听缩放等级 防止超过最小缩放
    zoom (value) {
      this.$nextTick(() => {
        if (value <= this.Pzoom) {
          this.zoom = this.Pzoom
        }
        this.lazyPoint()
      })
    },
    positions (value) {
      this.$nextTick(() => {
        if (value.length) {
          this.lazyPoint()
        }
      })
    }
  }
}
</script>

<style scoped>
#map{
  position:relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin:0;
  font-family:"微软雅黑";
}
.map{
  width: 100%;
  height: 100%;
}
.BMap_cpyCtrl {
  display: none;
}
.anchorBL {
  display: none;
}

</style>
